import { useState, useEffect } from 'react'

const useTabVisibility = () => {
  const [isTabActive, setIsTabActive] = useState(true)

  const handleVisibilityChange = () => {
    setIsTabActive(document.visibilityState === 'visible')
  }

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return isTabActive
}

export default useTabVisibility
